/* Football Masters native discount route helper.
 * Converts market promo URLs to Shopify /discount/CODE route before checkout.
 */
(function () {
  'use strict';

  if (window.__fmDiscountRouteFixLoaded) return;
  window.__fmDiscountRouteFixLoaded = true;

  var VERSION = '2026-06-15.eu-market-discount-route.1';
  var configs = {
    cz: {
      code: 'CZGK50',
      hosts: ['footballmasters.cz', 'www.footballmasters.cz'],
      pathPrefix: /^\/cs(\/|$)/i,
      lang: /^cs/i,
    },
    sk: {
      code: 'SKGK50',
      hosts: ['footballmasters.sk', 'www.footballmasters.sk'],
      pathPrefix: /^\/sk(\/|$)/i,
      lang: /^sk/i,
    },
    ro: {
      code: 'ROGK50',
      hosts: ['footballmasters.ro', 'www.footballmasters.ro'],
      pathPrefix: /^\/ro-ro(\/|$)/i,
      lang: /^ro/i,
    },
    de: {
      code: 'DEGK50',
      hosts: ['footballmasters.com.de', 'www.footballmasters.com.de'],
      pathPrefix: /^\/de(\/|$)/i,
      lang: /^de/i,
    },
  };

  function getConfig() {
    var host = (window.location.hostname || '').toLowerCase();
    var path = window.location.pathname || '/';
    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    var keys = Object.keys(configs);
    for (var index = 0; index < keys.length; index += 1) {
      var config = configs[keys[index]];
      if (config.hosts.indexOf(host) !== -1 || config.pathPrefix.test(path) || config.lang.test(lang)) {
        return config;
      }
    }
    return null;
  }

  var config = getConfig();
  if (!config) return;

  function safeSessionGet(key) {
    try {
      return window.sessionStorage && sessionStorage.getItem(key);
    } catch (error) {
      return '';
    }
  }

  function safeSessionSet(key, value) {
    try {
      if (window.sessionStorage) sessionStorage.setItem(key, value);
    } catch (error) {}
  }

  function isBlockedPath(path) {
    return /^\/(discount|checkout|checkouts|cdn|admin|apps|tools|wpm|\.well-known)(\/|$)/i.test(path || '');
  }

  function isCommercialPath(path) {
    return path === '/' ||
      /^\/(cs|sk|ro-ro|de)\/?$/i.test(path || '') ||
      /\/(collections|products|cart)(\/|$)/i.test(path || '');
  }

  function cleanRedirectTarget(url) {
    url.searchParams.delete('discount');
    return (url.pathname || '/') + (url.search || '') + (url.hash || '');
  }

  function routeFor(target) {
    return '/discount/' + encodeURIComponent(config.code) + '?redirect=' + encodeURIComponent(target || '/collections/all');
  }

  function applyNativeDiscountWhenNeeded() {
    try {
      var url = new URL(window.location.href);
      if (isBlockedPath(url.pathname)) return;

      var discountParam = (url.searchParams.get('discount') || '').toUpperCase();
      var explicitPromo = discountParam === config.code;
      if (!explicitPromo && !isCommercialPath(url.pathname)) return;

      var redirectTarget = cleanRedirectTarget(url);
      var routeKey = 'fmDiscountRouteFixApplied:' + config.code + ':' + redirectTarget;
      var marketKey = 'fmDiscountRouteFixMarketApplied:' + config.code;
      if (!explicitPromo && safeSessionGet(marketKey) === '1') return;
      if (safeSessionGet(routeKey) === '1') return;

      safeSessionSet(routeKey, '1');
      safeSessionSet(marketKey, '1');
      window.location.replace(routeFor(redirectTarget));
    } catch (error) {}
  }

  function discountRouteForLink(link) {
    try {
      var raw = link.getAttribute('href') || '';
      if (!raw || raw.charAt(0) === '#') return '';
      var url = new URL(raw, window.location.origin);
      if (url.hostname && url.hostname !== window.location.hostname) return '';
      var localizedDiscount = url.pathname.match(/^\/(?:cs|sk|ro-ro|de)\/discount\/([^/]+)(?:\/|$)/i);
      if (localizedDiscount && localizedDiscount[1].toUpperCase() === config.code) {
        return routeFor(url.searchParams.get('redirect') || '/collections/all');
      }
      if (isBlockedPath(url.pathname)) return '';
      var discount = (url.searchParams.get('discount') || '').toUpperCase();
      if (discount !== config.code) return '';
      return routeFor(cleanRedirectTarget(url));
    } catch (error) {
      return '';
    }
  }

  function rewriteDiscountLinks(root) {
    if (!root || !root.querySelectorAll) return;
    [].forEach.call(root.querySelectorAll('a[href]'), function (link) {
      var next = discountRouteForLink(link);
      if (next) link.setAttribute('href', next);
    });
  }

  function routeCheckoutSubmit(event) {
    var submitter = event.submitter || document.activeElement;
    if (!submitter || submitter.name !== 'checkout') return;
    safeSessionSet('fmDiscountRouteFixMarketApplied:' + config.code, '1');
  }

  function bindCartForms(root) {
    if (!root || !root.querySelectorAll) return;
    [].forEach.call(root.querySelectorAll('form[action*="/cart"]'), function (form) {
      if (form.dataset.fmDiscountRouteFixBound === '1') return;
      form.dataset.fmDiscountRouteFixBound = '1';
      form.addEventListener('submit', routeCheckoutSubmit, true);
    });
  }

  function run(root) {
    rewriteDiscountLinks(root || document);
    bindCartForms(root || document);
  }

  applyNativeDiscountWhenNeeded();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(document); });
  } else {
    run(document);
  }

  var timer = null;
  new MutationObserver(function (mutations) {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      mutations.forEach(function (mutation) {
        if (!mutation.addedNodes) return;
        [].forEach.call(mutation.addedNodes, function (node) {
          if (node && node.nodeType === 1) run(node);
        });
      });
    }, 80);
  }).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['href', 'action'],
    childList: true,
    subtree: true
  });

  window.setTimeout(function () { run(document); }, 500);
  window.setTimeout(function () { run(document); }, 1500);
  window.setTimeout(function () { run(document); }, 3500);

  window.__fmDiscountRouteFixVersion = VERSION;
})();
